import ViewLegacy from '../../../../pages/vpp/components/views/main/main';
import MshopsViewLegacy from '../../../../pages/vpp/components/views/main/main-mshops';
import ignoreViewOnNordicPage from '../../../ui-components/ignoreViewOnNordicPage';

const View = ignoreViewOnNordicPage(ViewLegacy);
const MshopsView = ignoreViewOnNordicPage(MshopsViewLegacy);

export default function renderView(props) {
  const { isShops = false } = props;

  if (isShops === true) {
    return <MshopsView {...props} />;
  }

  return <View {...props} />;
}
